import {
  ActionType,
  AutoTextField,
  CheckboxToggleField,
} from '../../components/AutoForm/AutoFieldNew';
import {investmentFieldsType} from '../../pages/PostcursorPage/postcursorFields';
import {GetRiskNotes} from '../../schema-types/GetRiskNotes';
import {RiskType} from '../../schema-types/globalTypes';
import {RiskProfileFragment} from '../../schema-types/RiskProfileFragment';
import {UpsertRiskNoteVariables} from '../../schema-types/UpsertRiskNote';
import {UpsertRiskNoteSectionVariables} from '../../schema-types/UpsertRiskNoteSection';
import {riskTypeToDisplays} from './riskNotesText';

export type riskNotesFormType = investmentFieldsType & {
  [RiskType.KNOWLEDGE_AND_BEHAVIOUR]: riskNotesFormSectionType;
  [RiskType.VALUES_AND_SERVICE]: riskNotesFormSectionType;
  [RiskType.FINANCIAL_CAPACITY]: riskNotesFormSectionType;

  centralPropositionAgreed?: boolean;
  dfmAgreed?: boolean;

  giaHasLiquidityNeeds: {
    [contactId: string]: boolean | null;
  };
  pensionHasLiquidityNeeds: {
    [contactId: string]: boolean | null;
  };

  hasNoRiskDicussion: boolean;
  noChangeReasonNotes: string;
  outcomeRisk: {
    [contactId: string]: outcomeRisk;
  };
};

export type outcomeRisk = {
  score: number | null;
  notes: string;
  riskToleranceQuestionnaireDeclineReason?: string;
  isRiskToleranceQuestionnaireDeclined: boolean;
};

export type riskNotesFormSectionType = {
  riskType: RiskType;
  notes: string;
  noChange: boolean | null;
};

export const riskNotesFormSectionNoChanges: (type: RiskType) => CheckboxToggleField = (
  type
) => {
  return {
    id: `${type}.noChange`,
    type: ActionType.checkboxToggle,
    label: `No changes`,
    requireSubmit: true,
  };
};

export const riskNotesFormSectionNote: (type: RiskType) => AutoTextField = (type) => {
  return {
    id: `${type}.notes`,
    type: ActionType.text,
    multiline: true,
    minRows: 8,
    label: `${riskTypeToDisplays[type].title} Notes`,
    labelOnTop: true,
    boldLabel: true,
    placeholder: `${riskTypeToDisplays[type].Description}`,
  };
};

export const riskToleranceQuestionnaireDeclineReasonField: (
  contactId?: string
) => AutoTextField = (contactId) => {
  return {
    id: `outcomeRisk.${contactId}.riskToleranceQuestionnaireDeclineReason`,
    type: ActionType.text,
    multiline: true,
    minRows: 8,
    label: `Reason client declined`,
    labelOnTop: true,
    boldLabel: true,
    placeholder: `Reason client declined`,
  };
};

export type UpsertRiskProfileSectionsOptions = {
  skipRefetch?: boolean;
};

type RiskNotesFormSectionProps = {
  upsertRiskProfileSections: (
    variables: UpsertRiskNoteSectionVariables,
    options?: UpsertRiskProfileSectionsOptions
  ) => void;
  upsertRiskSectionsLoading: boolean;
  upsertRiskSectionsError?: Error;
};
type RiskNotesFormUpdateProfileProps = {
  accountId: string;
  upsertRiskProfile: (variables: UpsertRiskNoteVariables) => void;
  upsertRiskProfileLoading: boolean;
  upsertRiskProfileError?: Error;
};
export type RiskNotesContextProps = {
  // eslint-disable-next-line react/no-unused-prop-types
  risk: GetRiskNotes;
  // eslint-disable-next-line react/no-unused-prop-types
  // eslint-disable-next-line react/no-unused-prop-types
  riskProfiles?: RiskProfileFragment[] | null;
  readOnly?: boolean;
  print: boolean;
};
export type RiskNotesFormProps = RiskNotesContextProps &
  RiskNotesFormSectionProps &
  RiskNotesFormUpdateProfileProps;
